import ErrorsMixin from "../mixins/errors-mixin";
import LoadingMixin from "../mixins/loading-mixin";

export default {
    mixins: [ErrorsMixin, LoadingMixin],
    data() {
        return {
            validPhone: false
        }
    },
    computed: {
        phone: {
            get() {
                return this.$store.getters.getPhone
            },
            set(newValue) {
                this.$store.commit('setPhone', newValue)
            }
        }
    },
    mounted() {
        $(this.$refs.phoneInput).mask('+7 (000) 000 00 00')
        this.validatePhone()
    },
    methods: {
        processPhone() {
            if (this.validPhone) {
                this.clearErrors();
                this.startLoader();

                this.$store.dispatch('processPhone', this.phone)
                    .then((response) => {
                        if (
                            response.status === 'success'
                            && !!response.data.step
                        ) {
                            this.$store.commit('setStep', response.data.step)
                        }
                    })
                    .catch((errors) => {
                        this.processErrors(errors)
                    })
                    .finally(this.stopLoader)

            }
        },
        saveAndValidatePhone(event) {
            this.phone = event.target.value
            this.validatePhone()
        },
        validatePhone() {
            let regEx = /\+7\s\(\d{3}\)\s\d{3}\s\d{2}\s\d{2}/
            this.validPhone = regEx.test(this.phone)
        }
    },
    // language=Vue
    template: `
      <div class="upblock__step">
       <div class="upblock__title">{{$Bitrix.Loc.getMessage('JS_MS_AF_PHONE_STEP_TITLE')}}</div>
          <div class="upblock__body js-val-container">
            <div class="upblock__body-wrapper">
              <div class="b-form-field-errors"
                   v-if="commonErrors.length > 0"
              >
                <div class="b-form-field-error"
                     v-for="(errorText, i) in commonErrors"
                     :key="i"
                >
                  {{errorText}}
                </div>
              </div>
              <div class="b-form-field"
                   :class="{'is-error': error.length > 0}"
              >
                <div class="b-form-field__wrapper js-phone-mask-auth-form">
                  <input class="b-form-field__input" 
                         type="text" 
                         placeholder="+7 (999) 999 99 99"
                         maxlength="18"
                         ref="phoneInput"
                         :value="phone"
                         @keyup="saveAndValidatePhone"
                  >
                </div>
                <div class="b-form-field-error"
                     v-if="error.length > 0"
                >
                  {{error}}
                </div>
              </div>
            </div>
            <div class="upblock__body-button js-btn-submit"
                 v-if="!localLoading"
                 :class="{'disabled': !validPhone}"
                 @click="processPhone"
            >
              {{$Bitrix.Loc.getMessage('JS_MS_AF_NEXT')}}
            </div>
            <div class="upblock__body-button js-btn-submit on-load"
                 v-else
            >
              {{$Bitrix.Loc.getMessage('JS_MS_AF_CHECKING')}}
            </div>
          </div>
      </div>
    `
}
